class CustomClickHandler extends GlobalClickHandler {

    handleClick(event){
        const categoryButton = event.target;

        if ( categoryButton.classList.contains('.sticky-modie-dropdown') ||  categoryButton.closest('.sticky-modie-dropdown') ) {
            const itemsContainer = document.querySelectorAll('.testimonial');
            const chevronIcon = document.querySelector('.chevron-icon-xx');

            if (itemsContainer) {
                itemsContainer.forEach(element => {
                    element.classList.toggle('sticky_modie_drpdwn_mb_items_hide');
                });
            }

           chevronIcon.classList.toggle('chevron-icon');
        }
    }

    superClassHandleClickTemplate(event) {
        this.handleClick(event)
    }
}

const handler = new CustomClickHandler();
